import { render, staticRenderFns } from "./ChongRecord.vue?vue&type=template&id=b1ae441c&scoped=true"
import script from "./ChongRecord.vue?vue&type=script&lang=js"
export * from "./ChongRecord.vue?vue&type=script&lang=js"
import style0 from "./ChongRecord.vue?vue&type=style&index=0&id=b1ae441c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ae441c",
  null
  
)

export default component.exports